<div class="container soft-warning-container row">
  <div class="col-1" (click)="closeToast()">
    <img class="warn-icon" src="https://cdn.catexpert.ab-inbev.com/assets/images/warning-icon.svg" />
  </div>
  <div class="col-10" (click)="closeToast()">
    {{ message }}
  </div>
  <div class="col-1">
    <img
      class="close-icon"
      (click)="closeToast()"
      src="https://cdn.catexpert.ab-inbev.com/assets/images/close-toast.svg"
    />
  </div>
</div>
